<template>
    <div>
        <template v-if="item[itemShowKey]">
            <el-form ref="assistantForm" class="el-form--floating" :style="isMultiple ? 'width: 250px' : 'width: 200px'">
                <el-form-item label="" class="el-form-item--normal-margin">
                    <!-- 多選：陣列即可；單選：需有至少一筆 placeholder -->
                    <template v-if="isMultiple ? Array.isArray(submitData[submitDataKey]) : (submitData[submitDataKey] && submitData[submitDataKey].length > 0)">
                        <div v-if="isMultiple" class="helper-select-multiple">
                            <el-select
                                v-model="selectedHelperIds"
                                multiple
                                collapse-tags
                                :multiple-limit="3"
                                placeholder="請選擇"
                            >
                                <el-option
                                    v-for="(assignItem, assignIndex) in assignList"
                                    :key="assignIndex"
                                    :value="assignItem.id"
                                    :label="assignItem.name"
                                >
                                    {{ assignItem.name }} ({{ assignItem.sameStore ? '同分店' : '不同分店' }})
                                </el-option>
                            </el-select>
                            <span class="helper-select-count">({{ selectedHelperIds.length }}/3)</span>
                        </div>
                        <el-select v-else v-model="submitData[submitDataKey][0].id">
                            <el-option label="不指派" value=""></el-option>
                            <el-option
                                v-for="(assignItem, assignIndex) in assignList"
                                :key="assignIndex"
                                :value="assignItem.id"
                                :label="`${assignItem.name} ${assignItem.sameStore ? '(同分店)' : '(不同分店)'}`"
                            >
                                {{ assignItem.name }} ({{ assignItem.sameStore ? '同分店' : '不同分店' }})
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
            </el-form>
        </template>
    </div>
</template>

<script>
const HELPER_MULTIPLE_LIMIT = 3

export default {
    name: 'HelperSelectOption',
    components: {},
    mixins: [],
    props: {
        itemShowKey: {
            type: String,
            require: true,
            default: ''
        },
        item: {
            type: Object,
            default: () => {},
            require: true
        },
        submitData: {
            type: Object,
            default: () => {},
            require: true
        },
        submitDataKey: {
            type: String,
            default: '',
            require: true
        },
        assignList: {
            type: Array,
            default: () => [],
            require: true
        }
    },
    data() {
        return {};
    },
    provide() { },
    inject: [],
    computed: {
        isMultiple() {
            return this.submitDataKey === 'helpers'
        },
        selectedHelperIds: {
            get() {
                const list = this.submitData[this.submitDataKey] || []
                return list.map(h => h.id).filter(id => id)
            },
            set(ids) {
                const limited = (ids || []).slice(0, HELPER_MULTIPLE_LIMIT)
                const helpers = limited.map(id => {
                    const found = this.assignList.find(a => a.id === id)
                    const existing = (this.submitData[this.submitDataKey] || []).find(h => h.id === id)
                    return {
                        id,
                        name: found ? found.name : (existing ? existing.name : ''),
                    }
                })
                this.$set(
                    this.submitData,
                    this.submitDataKey,
                    helpers.length > 0 ? helpers : [{ id: '', name: '' }]
                )
                this.$emit('update:submitData', this.submitData)
            }
        }
    },
    watch: {},
    created() { },
    mounted() { },
    methods: {},
};
</script>

<style lang="scss" module>
:global {
    .helper-select-multiple {
        display: flex;
        align-items: center;
        gap: 6px;

        .el-select {
            flex: 1;
            min-width: 0;
        }

        // 壓縮 tag，避免多選撐高蓋住下方「指定狀態」
        .el-select__tags {
            max-width: 100%;
            flex-wrap: nowrap;
            overflow: hidden;
        }

        .el-tag {
            max-width: 100px;

            .el-select__tags-text {
                display: inline-block;
                max-width: 70px;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: bottom;
            }
        }
    }

    .helper-select-count {
        flex-shrink: 0;
        line-height: 40px;
        font-size: 13px;
        color: #909399;
        white-space: nowrap;
    }
}
</style>
